import { render, staticRenderFns } from "./Search2.vue?vue&type=template&id=8b88e136&scoped=true&"
import script from "./Search2.vue?vue&type=script&lang=js&"
export * from "./Search2.vue?vue&type=script&lang=js&"
import style0 from "./Search2.vue?vue&type=style&index=0&id=8b88e136&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b88e136",
  null
  
)

export default component.exports